import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const ShipinhaoCheckLinkValidateParamsSchema = ActionCommonParamsSchema.extend({
    link: z.string(), // 需要验证的链接
});

export type ShipinhaoCheckLinkValidateParams = z.infer<typeof ShipinhaoCheckLinkValidateParamsSchema>;
